import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import theme from "../theme/Theme";
import { useSidebar } from "./Sidebar";

const Navbar = () => {
  const { toggleSidebar, isMobile } = useSidebar();
  const { logout } = useAuth();
  // const theme = useTheme();
  const navigate = useNavigate()

  // User profile menu
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
  console.log("Logging out...");
  
  try {
    // Clear localStorage first
    localStorage.removeItem("userType");
    localStorage.removeItem("userName");
    
    // Then call logout function
    await logout();
    
    // Navigate to login page
    navigate("/login", { replace: true });
    
    // Close menu if applicable
    handleMenuClose();
    
  } catch (error) {
    console.error("Logout error:", error);
    // Even if logout fails, clear local storage and redirect
    localStorage.clear();
    navigate("/login", { replace: true });
  }
};

  return (
    <AppBar
      position="sticky"
      sx={{
        width: "100%",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        boxShadow: 2,
        bgcolor: theme.palette.primary.main,
        transition: (theme) =>
          theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
      }}
    >
      <Toolbar>
        {isMobile && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open menu"
            onClick={(event) => {
              event.stopPropagation();
              toggleSidebar();
            }}
            sx={{ mr: 1, zIndex: 1 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {/* You can add a logo here */}
          Admin Dashboard
        </Typography>

        {/* {!isMobile && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="Notifications" onClick={handleNotifications}>
              <IconButton color="inherit" size="large">
                <NotificationsIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )} */}

        <Tooltip title="Account settings">
          <IconButton
            onClick={handleProfileMenuOpen}
            size="large"
            edge="end"
            aria-label="account of current user"
            aria-haspopup="true"
            color="inherit"
          >
            <Avatar sx={{ width: 32, height: 32, bgcolor: "secondary.main" }}>
              <AccountCircleIcon />
            </Avatar>
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={isMenuOpen}
          onClose={handleMenuClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.15))",
              mt: 1.5,
              minWidth: 180,
              "& .MuiMenuItem-root": {
                px: 2,
                py: 1,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={handleLogout}>
            <LogoutIcon fontSize="small" sx={{ mr: 2 }} />
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
